import styled from "styled-components";
import { FlexWrapper } from "../Common";

export const DesktopHeader = styled.div`
  display: flex;
  overflow: hidden;
  z-index: 1000000;
  background-color: transparent;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const MobileHeader = styled.div`
  display: none;
  overflow: hidden;
  z-index: 1000000;
  background-color: transparent;

  @media screen and (max-width: 768px) {
    display: flex;
  }
`;
export const HeaderWrapper = styled.div`
  width: 100vw;
  height: 90px;
  background-color: ${props=>props.isTransparent ? "transparent" : "black"};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  z-index: 1000000;
  @media screen and (max-width: 768px) {
    height: 50px;
  }
`;
export const Hamburger = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  margin-right: 50px;
  display: none;
  @media screen and (max-width: 768px) {
    display: flex;
    width: 25px;
    height: 25px;
  }
`;

export const HeaderSecondWrapper = styled.div`
  width: 45%;
  height: 100%;
  display: flex;
  background-color: ${(props) =>
    props.isTransparent ? "transparent" : "black"};

  align-items: center;
  justify-content: flex-end;
  padding-right: 80px;
`;

export const HeaderLink = styled.a`
  color: white;
  font-size: 1.3rem;
  text-decoration: none;
  margin: auto 15px;
  &:hover {
    div {
      width: 100%;
      transition: all 200ms linear;
    }
  }
  @media screen and (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const ImageLogo = styled.img`
  width: 200px;
  height: 50px;
  object-fit: contain;
  margin: 0 50px;
  @media screen and (max-width: 768px) {
    display: flex;
    width: 100px;
    height: 30px;
  }
`;

export const MobileHeaderWrapper = styled.div`
  width: 100vw;
  flex-direction: column;
  position: fixed;
  overflow: hidden;
  background-color: transparent;                              
  z-index: 1000000;
`;

export const MobileHeaderContainer = styled.div`
  width: 100%;
  background-color: black ; 
  margin-top: 90px;
  display: flex;
  flex-direction: column;
  max-height: ${(props) => (props.height ? "600px" : "0px")};
  transition: max-height 400ms linear;
  z-index: 1000000;
  @media screen and (max-width: 768px) {
    margin-top: 50px;
  }
`;

const UnderLineCmp = styled.div`
  width: 0px;
  height: 3px;
  display: block;
  border-radius: 50%;
  background-color: white;
`;

export const HeaderLinkCmp = ({title , link , onClick})=>{
  return (
    <FlexWrapper direction={"column"} width={"fit-content"} onClick={onClick}>
      <HeaderLink href={`${link}`}>
        <span>{title}</span>
        <UnderLineCmp/>
      </HeaderLink>
    </FlexWrapper>
  );
}
